import { render } from "./PuzzleCustomizer.vue?vue&type=template&id=2bfe8d06&scoped=true"
import script from "./PuzzleCustomizer.vue?vue&type=script&lang=js"
export * from "./PuzzleCustomizer.vue?vue&type=script&lang=js"

import "./PuzzleCustomizer.vue?vue&type=style&index=0&id=2bfe8d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfe8d06"]])

export default __exports__